"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEventAction = exports.removeSpecialCharacters = exports.setTargetURL = exports.clickEvent = exports.readyEvent = exports.impression = exports.debug = exports.isTrackingDisabled = exports.SharedTrackingServiceV2 = exports.ConsumerTrackingServiceV2 = void 0;
__exportStar(require("./types"), exports);
var consumer_1 = require("./consumer");
Object.defineProperty(exports, "ConsumerTrackingServiceV2", { enumerable: true, get: function () { return consumer_1.ConsumerTrackingServiceV2; } });
var shared_1 = require("./shared");
Object.defineProperty(exports, "SharedTrackingServiceV2", { enumerable: true, get: function () { return shared_1.SharedTrackingServiceV2; } });
var debugging_1 = require("./debugging");
Object.defineProperty(exports, "isTrackingDisabled", { enumerable: true, get: function () { return debugging_1.isTrackingDisabled; } });
Object.defineProperty(exports, "debug", { enumerable: true, get: function () { return debugging_1.debug; } });
var events_1 = require("./events");
Object.defineProperty(exports, "impression", { enumerable: true, get: function () { return events_1.impression; } });
Object.defineProperty(exports, "readyEvent", { enumerable: true, get: function () { return events_1.readyEvent; } });
Object.defineProperty(exports, "clickEvent", { enumerable: true, get: function () { return events_1.clickEvent; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "setTargetURL", { enumerable: true, get: function () { return utils_1.setTargetURL; } });
Object.defineProperty(exports, "removeSpecialCharacters", { enumerable: true, get: function () { return utils_1.removeSpecialCharacters; } });
Object.defineProperty(exports, "setEventAction", { enumerable: true, get: function () { return utils_1.setEventAction; } });
//# sourceMappingURL=index.js.map